import { render, staticRenderFns } from "./sign-up-form.vue?vue&type=template&id=e2766d34&scoped=true&"
import script from "./sign-up-form.vue?vue&type=script&lang=ts&"
export * from "./sign-up-form.vue?vue&type=script&lang=ts&"
import style0 from "./sign-up-form.vue?vue&type=style&index=0&id=e2766d34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2766d34",
  null
  
)

export default component.exports